import React, { FC } from 'react';
import classNames from 'classnames';
import Image from 'next/legacy/image';

import getClassNames from 'src/common/utils/getClassNames';
import { NEXT_STATIC_IMAGES } from 'src/common/constants';

import styles from './PitchPageLayout.module.scss';

export const HomepageBackgroundImageSrcs = [
  'home-page/palms.jpg',
  'home-page/how-it-works/texture.png',
] as const;

type HomepageBackgroundImageSrc = typeof HomepageBackgroundImageSrcs[number];

export type PitchPageLayoutProps = {
  /**
   * Optional section background color
   */
  backgroundColor?: 'midnight01' | 'midnight02' | 'ivory' | 'pearl' | 'bluminescence100';
  /**
   * Optional section background image.
   * Only use with backgroundColor when using transparent .svg or .png
   */
  backgroundImage?: HomepageBackgroundImageSrc;
  /**
  * The content section to render.
  */
  children: React.ReactNode;
  /**
   * Optional children meant to sit outside of component inner section
   */
  outerChildren?: React.ReactNode;
  /**
   * Optional section variant
   */
  variant?: 'header' | 'headerWithSearch';
  /**
   * For href reference
   */
  id?: string;
};

const PitchPageLayout: FC<PitchPageLayoutProps> = ({
  backgroundColor = 'pearl',
  backgroundImage,
  children,
  outerChildren,
  variant,
  id,
}) => (
  <div
    className={getClassNames(styles, 'root', classNames(backgroundColor, variant, {
      hasBackgroundColor: backgroundColor,
      hasBackgroundImage: backgroundImage,
    }))}
    id={id}
  >
    {backgroundImage && (
      <div className={styles.backgroundImage}>
        <Image
          src={`${NEXT_STATIC_IMAGES}${backgroundImage}`}
          objectFit="cover"
          layout="fill"
          sizes="100vw"
          className={
            backgroundImage === 'home-page/how-it-works/texture.png'
              ? styles.texture
              : styles.image
          }
          alt=""
          draggable="false"
        />
      </div>
    )}
    <section className={styles.inner}>
      {children}
    </section>
    {outerChildren}
  </div>
);

export default PitchPageLayout;
